/**
 * Implements a row with clickable images
 */
import { network_with_data } from '../NetworkSelector';
import Image from '../../atoms/Image';
import './styles.scss';

interface IChainSelectorProps {
    selected: string;
    onSet: (val: string) => void;
}

/**
 * Interactive chain selector
 * @param props
 * @returns
 */
const ChainSelector = ({ selected, onSet }: IChainSelectorProps) =>
  (<div className='chain__selector'>
    {network_with_data.map((item: any) =>
      (<div
        key={item.chain}
        className={`chain__selector__item ${item.slug == selected ? 'chain__selector__item--active' : ''}`}
        onClick={() => onSet(item.slug)}
      >
        <Image
          src={item.image}
          size='l'
          alt={item.chain}
        />
      </div>)
    )}
  </div>);

export default ChainSelector;
